<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv" style="height: -webkit-fill-available">
            <mat-toolbar class="agGridtoperDiv card" style="
                  background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-left: 1px solid #a9a9a9a8;">
                  <label i18n="@@spmsUserReg" class="textColour">Object Relationship</label>

                  <div class="selectRecordsDiv" style="display: inline-block;">
                    <!-- **************************
                     *@ModifiedBy: Shyam
                     @Date : 10-06-2025
                     @Note added dropsown of dns to show particular objects based on selected dns
                     ********************     -->
                            <mat-form-field appearance="outline" style="width: 80%;">
                                <mat-label i18n="@@Targetstdcode" style="color:black">Select DNS</mat-label>
                                <mat-select [ngModelOptions]="{standalone:true}" [(ngModel)]="name" (ngModelChange)="selectDns($event)">
                                    <mat-option style="font-size: 15px;" *ngFor="let eachdns of dnsnames" [value]="eachdns.name" [disabled]="isEnabled">
                                        {{eachdns.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


              <!-- <span class="example-spacer"></span> -->
              <!-- ========================================================== -->
              
              <button class="popup gridColour btn btn-rounded-button z-depth-1
                      waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" [style.min-width.px]="60"
                style="font-size: 12px; padding:0; height: 32px;" id="102" title="Import Data" (click)="importData()">
                Import
                <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
              </button>
              <!-- Import Button -->
              <button class="popup gridColour btn btn-rounded-button z-depth-1
                                             waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                [style.min-width.px]="60" style="font-size: 12px; padding: 0; height: 32px;" id="103" title="Export Data"
                (click)="exportData()">
                Export
                <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
              </button>
              
              <!-- ================================================ -->
              <!-- <input type="file" #fileInput  style="display: none;" (change)="onFileChange($event)"> -->
              <!-- Upload File Button -->
              <button  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                [style.background-color]="backgroundColorButton"
                                title="Upload File" id="108"
                                (click)="excelFileUploadForObjects()">
                          Upload File
              <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
              </button>
              <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Add Record" (click) = "openSaveForm('Save')" [disabled]="isdisable" id="114">Add Record
                <em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
              </button>
              <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Add Record" (click) = "downloadListFile()" [disabled]="isdisable">Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Add Record"></em>
              </button> -->
              <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (keyup.enter)="onSearchChange($event.target.value)">
                </mat-form-field>
              </div>
              <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged($event)"                   >
                    <mat-option [value]="10">10</mat-option>
                    <mat-option [value]="20">20</mat-option>
                    <mat-option [value]="50">50</mat-option>
                    <mat-option [value]="100">100</mat-option>
                  </mat-select>
  
                </mat-form-field>
              </div>
              <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
              </div>
              <div class="card pagination paginationButtons btn-rounded">
                <ul>
                  <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                                  (click)="onBtPrevious()"></em></li>
                  <li>{{currentPage}}/{{totalPages}}</li>
                  <li class="paginationliicon" style="padding:0;"><em
                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                </ul>
              </div>
              <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
              </div>
            </mat-toolbar>
            <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
            [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true"
            [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
            [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
             [paginationNumberFormatter]="paginationNumberFormatter" (paginationChanged)="onPaginationChanged()"
            [enableRangeSelection]="true" [debug]="true"[paginationPageSize]="pageSize"
            [components]="components" [rowClassRules]="rowClassRules"
            (gridReady)="onGridReady($event)" [hidden]="!true"></ag-grid-angular>
        </div>
    </div>